import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="font-mono text-[0.7rem] tracking-[0.25em] uppercase text-teal mb-4">
            Contact
          </div>
          <h1 className="font-display text-[clamp(2.5rem,5vw,4rem)] tracking-[0.04em] leading-none text-white mb-6">
            Get in touch.
          </h1>
          <p className="text-[1rem] font-light leading-[1.8] text-white/[0.65] max-w-[640px]">
            Whether you're a filmmaker, sponsor, press, or just curious — we'd love to hear from you.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <ContactForm />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="space-y-8"
          >
            <div>
              <h3 className="font-display text-xl text-teal mb-3">FILMMAKERS & SUBMISSIONS</h3>
              <a
                href="mailto:synemafest@gmail.com"
                className="text-[1.1rem] font-light text-white/70 hover:text-white transition-colors"
              >
                synemafest@gmail.com
              </a>
              <p className="text-[0.85rem] font-light text-white/40 mt-2 leading-relaxed">
                For all questions about submissions, fee waivers, eligibility, and film selection.
              </p>
            </div>

            <div>
              <h3 className="font-display text-xl text-teal mb-3">GENERAL INQUIRIES</h3>
              <a
                href="mailto:synemafest@gmail.com"
                className="text-[1.1rem] font-light text-white/70 hover:text-white transition-colors"
              >
                synemafest@gmail.com
              </a>
              <p className="text-[0.85rem] font-light text-white/40 mt-2 leading-relaxed">
                For sponsors, press, affiliates, partnerships, and everything else.
              </p>
            </div>

            <div className="bg-dark2 border border-white/[0.06] rounded p-6">
              <h3 className="font-display text-lg text-white mb-2">KEY DATES</h3>
              <div className="space-y-2 text-[0.85rem] font-light text-white/50">
                <div className="flex justify-between">
                  <span>Early Bird Deadline</span>
                  <span className="font-mono text-teal">Sep 18, 2026</span>
                </div>
                <div className="flex justify-between">
                  <span>Regular Deadline</span>
                  <span className="font-mono text-teal">Oct 23, 2026</span>
                </div>
                <div className="flex justify-between">
                  <span>Late Deadline</span>
                  <span className="font-mono text-teal">Nov 20, 2026</span>
                </div>
                <div className="flex justify-between">
                  <span>Notifications</span>
                  <span className="font-mono text-teal">Jan 5, 2027</span>
                </div>
                <div className="flex justify-between border-t border-white/[0.06] pt-2 mt-2">
                  <span className="font-medium text-white">Festival</span>
                  <span className="font-mono text-orange">Jan 21–24, 2027</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
